import ReactDOM from 'react-dom/client';
import App from './App';

import './i18n';
import './index.css';
import "./lib/firebase";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);
